import {useQuery, gql} from '@apollo/client'
import useRouteBasedSkip from '../../hooks/useRouteBasedSkip'

const QUERY_HEALTH_AND_EQUITY_CONDITION_LIST = gql`
  query healthEquityConditionList {
    healthEquityConditonList {
      HEALTH_EQUITY_CONDITION_NAME
      HEALTH_EQUITY_CONDITION_KEY
    }
  }
`

/**
 * Query hook for fetching health and equity condition list
 * Used by time series components
 */
export function useHealthAndEquity() {
  const shouldSkip = useRouteBasedSkip('/timeseries')

  const {
    data: healthAndEquityConditions,
    loading: loadingHealthAndEquityConditions,
    refetch: refetchHealthAndEquityConditions,
    error: errorLoadingHealthAndEquityConditions
  } = useQuery(QUERY_HEALTH_AND_EQUITY_CONDITION_LIST, {
    context: {clientName: 'longitudinal'},
    notifyOnNetworkStatusChange: true,
    skip: shouldSkip
  })

  return {
    healthAndEquityConditions,
    loadingHealthAndEquityConditions,
    refetchHealthAndEquityConditions,
    errorLoadingHealthAndEquityConditions
  }
}
